import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Breadcum from "../layout/refactor/Breadcum/Breadcum";
import Common from "../based/Common";
import CommonTablePagination from "../based/CommonTablePagination";
import { INITPAGING, PLATFORM, STATUS_TRANSACTION } from "../based/Constants";
import FinanceOrderDetail from "./FinanceOrderDetail";
import FinanceServices from "../based/services/FinanceServices";

function FinanceTiktokShop(props) {
    const [paging, setPaging] = useState({ ...INITPAGING, pageNumber: 1, pageSize: 100, platform: PLATFORM.Tiktok });
    const [showDetail, setShowDetail] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState(0);
    const [data, setData] = useState([]);
    const [financeOverview, setFinanceOverview] = useState({});

    console.log("financeOverview", financeOverview);

    useEffect(() => {
        getData(paging);
        getFinanceOverview();
    }, []);

    function handleChangePage(page) {
        let newPaging = {
            ...paging,
            pageNumber: page,
        };
        getData(newPaging);
    }

    function handleChangePageSize(pageSize) {
        let newPaging = {
            ...paging,
            pageNumber: 1,
            pageSize: pageSize,
        };
        getData(newPaging);
    }

    const getData = async (page) => {
        const [err, data] = await FinanceServices.GetCreatorOrderModelByPageModel(page);
        if (!err && data) {
            setData(data.listObjects);
            setPaging(data.paging);
        } else {
            setData([]);
            setPaging(page);
        }
    };

    const getFinanceOverview = async () => {
        const [err, data] = await FinanceServices.GetFinanceOverviewAsync(PLATFORM.Tiktok);
        if (!err && data) {
            setFinanceOverview(data);
        } else {
            setFinanceOverview({});
        }
    };

    return (
        <React.Fragment>
            <Breadcum
                options={[
                    {
                        value: "/",
                        label: "Trang chủ",
                    },
                    {
                        value: location.pathname,
                        label: "Tài chính Tiktok Shop",
                    },
                ]}
                title={"Tài chính Tiktok Shop"}
            />
            <Wrapper>
                <section className="order-overview">
                    <div className="overview-header">
                        <h6>Tiền bản quyền</h6>
                    </div>
                    {financeOverview && (
                        <div className="overview-body">
                            <div className="notyet">
                                <label htmlFor="">Tổng tiền bản quyền</label>
                                <div className="pricing highlight">{Common.formatCurrency(financeOverview.loyaltyAmount)}</div>
                            </div>
                            <div className="separate-icon">
                                <span>=</span>
                            </div>
                            <div className="revenue">
                                <label htmlFor="">Tổng doanh thu</label>
                                <div className="pricing">{Common.formatCurrency(financeOverview.finallyPrice)}</div>
                            </div>
                            <div className="separate-icon">
                                <span>-</span>
                            </div>
                            <div className="vat">
                                <label htmlFor="">Thuế VAT 8%</label>
                                <div className="pricing">{Common.formatCurrency(financeOverview.vatCost)}</div>
                            </div>
                            <div className="separate-icon">
                                <span>-</span>
                            </div>
                            <div className="production">
                                <label htmlFor="">Tổng chi phí sản xuất</label>
                                <div className="pricing">{Common.formatCurrency(financeOverview.productionCost)}</div>
                            </div>
                            <div className="separate-icon">
                                <span>-</span>
                            </div>
                            <div className="tncn">
                                <label htmlFor="">Tổng chi phí vận chuyển</label>
                                <div className="pricing">{Common.formatCurrency(financeOverview.shippingFee)}</div>
                            </div>
                        </div>
                    )}
                </section>
                <section className="order-manage">
                    <div className="order-header">
                        <h6>Đơn hàng</h6>
                        <div className="list-action">
                            <div className="action-left"></div>
                            <div className="action-right"></div>
                        </div>
                        <div className="order-header-filter">
                            <div className="order-timerange-filter"></div>
                        </div>
                    </div>
                    <div className="order-body">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th className="center">Đơn hàng</th>
                                    <th className="center">Ngày đặt hàng</th>
                                    <th className="center">Ngày quyết toán</th>
                                    <th className="center">Trạng thái</th>
                                    <th className="center">Doanh thu ước tính</th>
                                    <th className="center">Chi phí sản xuất và vận chuyển</th>
                                    <th className="center">Lợi nhuận tạm tính</th>
                                    <th className="center">Thao tác</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.length > 0 ? (
                                    data.map((item, index) => {
                                        let clBadge = `badge-custom`;
                                        if (item.status == STATUS_TRANSACTION.SUCCEED) clBadge = `badge-success`;
                                        else if (item.status == STATUS_TRANSACTION.RETURNED_TO_SENDER) clBadge = `badge-danger`;
                                        return (
                                            <tr key={index}>
                                                <td className="center">
                                                    <div className="order-number-detail">
                                                        <span
                                                            className="order-number cursor-pointer"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                navigator.clipboard.writeText(item.orderNumber);
                                                            }}
                                                        >
                                                            #{item.orderNumber}
                                                            <i className="fa fa-copy"></i>
                                                        </span>
                                                        {/* <span className="order-detail">5 sản phẩm</span> */}
                                                    </div>
                                                </td>
                                                <td className="center">{Common.formatDate(new Date(item.createdDate))}</td>
                                                <td className="center">{item.closingDate && Common.formatDate(new Date(item.closingDate))}</td>
                                                <td className="center">
                                                    <span className={`badge ${clBadge}`}>{item.statusName}</span>
                                                </td>
                                                <td className="center">{Common.formatCurrency(item.finallyPrice)}</td>
                                                <td className="center">{Common.formatCurrency(item.totalCost)}</td>
                                                <td className="center">
                                                    <div className="highligh-revenue green">{Common.formatCurrency(item.totalLoyalty)}</div>
                                                </td>
                                                <td className="center">
                                                    <a
                                                        href=""
                                                        className="text text-custom"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setShowDetail(true);
                                                            setSelectedOrderId(+item.orderId);
                                                        }}
                                                    >
                                                        Chi tiết <i className="fa fa-chevron-right"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center">
                                            Không có dữ liệu
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div className="table-bottom">
                            <CommonTablePagination paging={paging} onChangePage={handleChangePage} onChangePageSize={handleChangePageSize} />
                        </div>
                    </div>
                </section>
            </Wrapper>
            <FinanceOrderDetail
                show={showDetail}
                onClose={() => {
                    setShowDetail(false);
                    setSelectedOrderId(0);
                }}
                orderId={selectedOrderId}
            />
        </React.Fragment>
    );
}

export default FinanceTiktokShop;

const Wrapper = styled.div`
    section.order-overview {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 24px;
    }

    .overview-body {
        display: flex;
        align-items: center;
        justify-content: space-around;
    }

    .overview-header h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin: 0;
    }

    .overview-header {
        margin-bottom: 18px;
    }

    .notyet {
        border-radius: 12px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 12px;
        min-width: 180px;
    }

    .revenue {
        border-radius: 12px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 12px;
        min-width: 180px;
    }

    .vat {
        border-radius: 12px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 12px;
    }

    .production {
        border-radius: 12px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 12px;
        min-width: 180px;
    }

    .tncn {
        border-radius: 12px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 12px;
        min-width: 180px;
    }

    .separate-icon {
        margin: 0 18px;
    }

    .overview-body label {
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: calc(100% - 30);
    }

    .separate-icon span {
        width: 8px;
        display: inline-block;
        font-weight: 600;
    }

    .pricing.highlight {
        color: #ff9027;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .pricing {
        color: #303030;
        font-family: Lexend;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    section.order-manage {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        margin: 12px 0;
    }

    .order-header h6 {
        margin: 0;
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .order-header {
        padding: 24px;
        border: 1px solid #f3f3f3;
    }

    .order-body {
        padding: 12px 24px;
    }

    table.table.table-bordered thead {
        background: #f3f3f3;
        border-radius: 12px;
        overflow: hidden;
    }

    table.table.table-bordered {
        border-radius: 12px;
    }

    table.table.table-bordered thead tr th {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .order-number-detail {
        display: flex;
        flex-direction: column;
    }

    span.order-number {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    span.order-number .fa {
        color: rgba(160, 160, 160, 1);
        margin-left: 6px;
    }

    span.order-detail {
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 6px 0;
    }

    tbody tr td {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
`;
